import React from "react";
import { Link } from "react-router-dom";

export default class Footer extends React.Component {
  render() {
    let publicUrl = process.env.PUBLIC_URL + "/";
    return (
      <>
        <footer className="footer-one-sec">
          <div
            className="footer-one__pattern"
            style={{
              backgroundImage:
                "url(" +
                publicUrl +
                "assets/images/pattern/bricks-pattern.jpg)",
            }}
          ></div>
          <div className="footer-one__top">
            <div className="footer-one__top-img"></div>
            <div className="container">
              <div className="row">
                <div className="col-xl-12">
                  <div className="footer-one__top-inner">
                    <div className="row">
                      <div
                        className="col-xl-6 col-lg-6 col-md-6 wow animated fadeInUp"
                        data-wow-delay="0.1s"
                      >
                        <div className="footer-widget__column footer-widget__about">
                          <div className="footer-widget__about-logo">
                            <Link to="/">
                              <img
                                src={
                                  publicUrl +
                                  "assets/images/logo/logo-black-white.png"
                                }
                                alt="Logo"
                              />
                            </Link>
                          </div>

                          <p className="footer-widget__about-text">
                            Kalkan Gradnja je porodični biznis sa tradicijom
                            dugom preko 25 godina, tokom koje smo razvili uvezan
                            i pouzdan sistem rada koji nam omogućava kvalitetnu
                            i efikasnu realizaciju svih građevinskih projekata.
                          </p>

                          <div className="footer-widget__about-social-link">
                            <ul>
                              <li>
                                <a href="https://www.facebook.com/kalkangradnja/?locale=hr_HR">
                                  <span className="first icon-facebook-app-symbol"></span>
                                  <span className="second icon-facebook-app-symbol"></span>
                                </a>
                              </li>
                              <li>
                                <a href="https://www.instagram.com/kalkangradnja/">
                                  <span className="first">
                                    <img
                                      style={{
                                        maxWidth: "16px",
                                        maxHeight: "16px",
                                      }}
                                      src="./assets/images/instagram2.svg"
                                      alt="Instagram"
                                    />
                                  </span>
                                  <span className="second">
                                    <img
                                      style={{
                                        maxWidth: "16px",
                                        maxHeight: "16px",
                                      }}
                                      src="./assets/images/instagram.svg"
                                      alt="Instagram"
                                    />
                                  </span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>

                      <div
                        className="col-xl-3 col-lg-6 col-md-6 wow animated fadeInUp"
                        data-wow-delay="0.3s"
                      >
                        <div className="footer-widget__column footer-widget__services">
                          <h2 className="footer-widget__title">Linkovi</h2>
                          <ul className="footer-widget__services-list">
                            <li className="footer-widget__services-list-item">
                              <Link to="#about">O nama</Link>
                            </li>
                            <li className="footer-widget__services-list-item">
                              <Link to="#services">Naši radovi</Link>
                            </li>
                            <li className="footer-widget__services-list-item">
                              <Link to="/">Reference</Link>
                            </li>
                            <li className="footer-widget__services-list-item">
                              <Link to="#contact">Kontakt</Link>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div
                        className="col-xl-3 col-lg-6 col-md-6 wow animated fadeInUp"
                        data-wow-delay="0.5s"
                      >
                        <div className="footer-widget__column footer-widget__explore">
                          <h2 className="footer-widget__title">Kontakt</h2>
                          <ul className="footer-widget__explore-list">
                            <li className="footer-widget__explore-list-item">
                              <p>
                                <i className="fas fa-map-pin" /> I. Bataljona
                                77A, Sarajevo
                              </p>
                            </li>
                            <li className="footer-widget__explore-list-item">
                              <p>
                                <i className="fas fa-phone" /> +387 (62) 386-911
                              </p>
                            </li>
                            <li className="footer-widget__explore-list-item">
                              <p>
                                <i className="fas fa-envelope" />{" "}
                                kalkanod@outlook.com
                              </p>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-one__bottom clearfix">
            <div className="container">
              <div className="row">
                <div className="col-xl-12">
                  <div className="footer-one__bottom-inner">
                    <div className="footer-one__bottom-text">
                      <p>
                        Copyright &copy;2025. All rights reserved to{" "}
                        <a href="https://www.smartapps.ba" target="_blank">
                          smartapps.ba
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </>
    );
  }
}
